<script setup>
import "@/assets/main.css";

</script>
<template>
    <div class="relative w-full flex flex-col">
        <div class="flex relative h-fit justify-end py-10">
            <div
                class="main-content relative z-20 flex flex-col justify-center text-center sm:w-[60%] md:w-full h-[55%] mx-7">
                <div>
                    <p class="font-parisienne text-gold-dark text-4xl mb-3 ">
                        Om Swastyastu
                    </p>
                    <p class="text-sm text-alt-dark">
                        Atas Asung Kerta Wara Nugraha Ida Sang Hyang Widhi Wasa, kami
                        bermaksud mengundang Bapak/Ibu/Saudara/i untuk hadir pada upacara
                        telubulanan anak kami.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>
